import "./bootstrap";

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import Vuex from "vuex";
import mainStore from "./store";
import { ServerTable } from "vue-tables-2";
import VueMask from 'v-mask'
import VueToastr from "@deveodk/vue-toastr";
import VueEllipseProgress from 'vue-ellipse-progress';
import vSelect from 'vue-select';
import Vue2Editor from "vue2-editor";
import 'vue-select/dist/vue-select.css';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';


const translation = {
    count: "Mostrando {from} de {to} até {count} de registros",
    filter: "Pesquisar:",
    filterBy: 'Filtrar por {column}',
    filterPlaceholder: "Pesquisar",
    limit: "Registros:",
    noResults: "Nenhum registro encontrado",
    page: "Página:"
    // for dropdown pagination filterBy: 'Filter by {column}',
    // Placeholder for search fields when filtering by column loading:'Loading...',
    // First request to server defaultOption:'Select {column}'
    // default option for list filters }
};

const options = {
    requestFunction: function (data) {
        // data.token = this.$store.getters.token
        return axios
            .get(this.url, {
                params: data
            })
            .catch(
                function (e) {
                    this.dispatch("error", e);
                    router.push("/domains/login");
                }.bind(this)
            );
    },
    texts: translation,
    pagination: { chunk: 15, dropdown: false, nav: "scroll" },
    perPage: 10,
    perPageValues: [10, 25, 50, 100]
};

Vue.config.productionTip = false;
Vue.use(Vuex);
Vue.use(router);
Vue.use(ServerTable, options, false, "bootstrap3", "footerPagination");
Vue.use(VueToastr);
Vue.use(VueEllipseProgress);
Vue.use(VueMask);
Vue.use(Vue2Editor);
Vue.use(Loading);
Vue.component('v-select', vSelect)

export const store = new Vuex.Store(mainStore);

/* eslint-disable no-new */
new Vue({
    el: "#app",
    router,
    store,
    components: { App },
    template: "<App/>",
    created() {
        this.$store.dispatch("initialize");
    }
});

import "./assets/sass/app.scss";
import "./assets/js/inspinia";
import "./assets/js/plugins/bootstrap-duallistbox/src/bootstrap-duallistbox.css";
import "./assets/js/plugins/metisMenu/jquery.metisMenu";
import "./assets/js/plugins/slimscroll/jquery.slimscroll";
import "./assets/js/plugins/bootstrap-duallistbox/src/jquery.bootstrap-duallistbox";
import "@deveodk/vue-toastr/dist/@deveodk/vue-toastr.css";
import swal from "sweetalert";
import "../node_modules/moment/moment";
import "../node_modules/selectize/dist/css/selectize.bootstrap3.css";
import "../node_modules/jquery-contextmenu/dist/jquery.contextMenu.css";
import "./assets/js/plugins/clockpicker/clockpicker";
import "./assets/sass/plugins/clockpicker/clockpicker.css";

import "../node_modules/fullcalendar/dist/fullcalendar.min.css";

import "../node_modules/jquery-ui-dist/jquery-ui.min.css";
import "../node_modules/jquery-ui-dist/jquery-ui.min.js";

import '../node_modules/moment/moment'


import '../node_modules/daterangepicker/daterangepicker.js'
import '../node_modules/daterangepicker/daterangepicker.css'

// import "./assets/js/plugins/fullcalendar/pt-br.js";
// import "./assets/js/plugins/fullcalendar/locale.js";
// import "./assets/js/plugins/fullcalendar/moment.min.js";
// import "./assets/js/plugins/fullcalendar/fullcalendar.min.js";

window.moment = require('moment');

Vue.prototype.$http = window.axios;
Vue.prototype.$message = function (title, msg, type) {
    this.$toastr("add", {
        title: title,
        msg: msg,
        clickClose: true,
        timeout: 2000,
        position: "toast-top-right",
        type: type
    });
};
Vue.prototype.$error = function (error) {
    let errors = (error.response) ? error.response.data : error;
    if (typeof errors === 'object') {
        let html = '<ul>';
        $.each(errors, function (key, value) {
            html += '<li>' + value[0] + '</li>';
        });
        html += '</ul>';
        errors = html;
    }
    this.$message(null, errors, 'error');
};


// WEBPACK FOOTER //
// ./src/main.js